import { cn } from '@/context/global/utils/cn';

type IconAddProps = {
  size?: number;
  className?: string;
};

const IconAdd = ({ size = 24, className }: IconAddProps) => {
  return (
    <svg
      className={cn('stroke-current', className)}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5V19"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 12H19"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconAdd;
